import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import MultiPageSearchResultsContainer from 'redux/containers/pages/search/MultiPageSearchResultsContainer'

const MultiPageSearch = (props) => {
  if (!props.searchResults) return null

  return (
    <ResponseConsumer
      response={props.searchResults}
      content={() => (
        <MultiPageSearchResultsContainer
          {...props}
          // requestPage={() => requestPage(props)}
        />
      )}
    />
  )
}

export default MultiPageSearch
